import * as React from 'react';
import Table from './investmentRestrictions/Table';

const investmentRestrictions = (props) => {
  const { reviewId, reference, reviewEndDate } = props;
  return <Table reviewId={reviewId} reference={reference} endDate={reviewEndDate} />;
};

export default investmentRestrictions;
